export default __webpack_public_path__ + "static/media/Selma Soares.16175a6b.png";